import clsx from 'clsx'
import styleUtils from 'shared-components/styles/util.module.css'
import styles from './ContactsTemplate.module.css'
import MailBlock from 'shared-components/ui/MailBlock'
import AdvertiseLink from 'shared-components/ui/AdvertiseLink'
import FormBuilder from 'shared-components/form/FormBuilder'
import { publicConfig } from 'config'
import { CommonDataContext } from 'shared-components/contexts/CommonDataContext'
import BasicButton from 'shared-components/buttons/BasicButton'
import { useCallback, useEffect, useState } from 'react'
import { getds } from 'ds'
import { parse } from 'query-string'
import { DSContactsPage } from 'shared-definitions/types'
import { useFormAppEvents } from 'shared-components/hooks/use-form-app-events'

interface ContactsTemplateProps {
  page: DSContactsPage
  // onSubmit: (data: any) => Promise<boolean>
}

const ContactsTemplate: React.VFC<ContactsTemplateProps> = ({ page }) => {
  const {
    ts,
    common: { strings },
  } = CommonDataContext.useContainer()
  const [submitting, setSubmitting] = useState(false)
  const [defaults, setDefaults] = useState<Record<string, string>>({})
  useEffect(() => {
    const { message } = parse(window.location.search)
    if (!message || typeof message !== 'string') {
      return
    }
    setDefaults(s => ({
      ...s,
      message: decodeURI(message),
    }))
  }, [])
  const { formSuccessEvent, formFailureEvent, formStartedEvent } = useFormAppEvents()

  const onSubmit = useCallback(
    async (data: any) => {
      setSubmitting(true)

      const formEventPayload = {
        name: 'contact-us',
        id: 'contact-us',
      } as const

      formStartedEvent(formEventPayload)

      const dataSource = await getds({ ts })
      const { code } = await dataSource.sendContacts(data)

      if (code === 200) {
        formSuccessEvent(formEventPayload)
      } else {
        formFailureEvent(formEventPayload)
      }

      setSubmitting(false)
      return code === 200
    },
    [ts]
  )
  return (
    <div className={styleUtils.wrapper}>
      <h1 className={clsx(styleUtils.pageTitle, styleUtils.pageTitleMargins)}>{page.title}</h1>
      <div className={styles.afterText}>{page.text}</div>
      <div className={styles.cards}>
        {page.emails.map((item, index) => (
          <MailBlock card={item} key={index} />
        ))}
      </div>
      <h5 className={styles.advTitle}>{page.advertise.title}</h5>
      <AdvertiseLink variant="normal" className={styles.advButton} {...page.advertise.button.pLink}>
        {page.advertise.button.label}
      </AdvertiseLink>
      <h3 id={publicConfig('contactsFormId')} className={styles.formTitle}>
        {page.form.title}
      </h3>

      <FormBuilder
        className={clsx(styles.formContainer, { [styles.formContainerSubmitting]: submitting })}
        onSubmit={onSubmit}
        fields={page.form.fields.map(item => ({
          ...item,
          value: defaults[item.name] ?? item.value,
          className: clsx({ [styles.formTextarea]: item.type === 'textarea' }),
        }))}
      >
        {({ components }) => (
          <>
            {components}
            <BasicButton className={styles.formButton} type="submit">
              {strings.msgSubmit}
            </BasicButton>
          </>
        )}
      </FormBuilder>
    </div>
  )
}

export default ContactsTemplate
